import * as React from 'react';

import { LocalizedComponentProps } from 'bernie-l10n';

import { UitkProgressBar } from 'uitk-react-progress-bar';

import { ReviewsViewModel } from 'models/hotel';

export interface BarRatingsModel extends LocalizedComponentProps {
  reviews: ReviewsViewModel;
  className?: string;
  barClassName?: string;
}

export const MAX_RATING = 5;

export interface ProgressBarProps {
  percent: number;
  title: string;
  progressDescription: string;
}

export const BarRatings = ({ reviews, l10n, className, barClassName }: BarRatingsModel) => {
  const categoryRatings: ProgressBarProps[] =
    reviews.overallRating > 0
      ? [
          {
            title: l10n.formatText('hotels.infosite.reviews.roomCleanliness.title'),
            percent: reviews.cleanlinessPercent,
            progressDescription: reviews.cleanlinessOverMax
          },
          {
            title: l10n.formatText('hotels.infosite.reviews.serviceAndStaff.title'),
            percent: reviews.serviceAndStaffPercent,
            progressDescription: reviews.serviceAndStaffOverMax
          },
          {
            title: l10n.formatText('hotels.infosite.reviews.amenities.title'),
            percent: reviews.amenityScorePercent,
            progressDescription: reviews.amenityScoreOverMax
          },
          {
            title: l10n.formatText('hotels.infosite.reviews.hotelCondition.title'),
            percent: reviews.hotelConditionPercent,
            progressDescription: reviews.hotelConditionOverMax
          }
        ]
      : [];

  return (
    <div className={className}>
      {categoryRatings.map(categoryRating => {
        if (categoryRating.percent === 0) {
          return null;
        }

        return (
          <div key={`bar-rating-${categoryRating.title}`} className="uitk-cell">
            <UitkProgressBar {...categoryRating} />
          </div>
        );
      })}
    </div>
  );
};
